<style>
@import '../../assets/css/transaction.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <el-input v-model="ajaxSearch.master_id" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date')}}</template>
                        <b-form-input v-model="ajaxSearch.created_at" type="date"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_total_value')}}</template>
                        <el-input v-model="ajaxSearch.total_value" clearable></el-input>
                    </b-form-group>
                     <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_is_pay')}}</template>
                        <el-input v-model="ajaxSearch.is_pay" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        <template slot="header">
                            <p>{{title.label}}</p>
                            <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column type="expand">
                        <b-button variant="info" size="lg" @click="infoBonus()">{{$t('admin.table_bonus_info')}}</b-button>
                    </el-table-column>
                </el-table>
                <b-row class="mt-3">
                    <b-col sm="12" md="3" class="pr-0">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                    </b-col>
                    <b-col sm="12" md="9" class="pl-0">
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <b-modal id="infoBonus" :title="$t('admin.table_bonus_info')" hide-footer size="xl">
            <el-table class="custom-table" :data="ajaxTableBonusInfo" ref="tableTestBonusInfo" border>
                <el-table-column v-for="title in titlesBonusInfo" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                </el-table-column>
            </el-table>
            <b-row class="mt-3">
                <b-col sm="12" md="3" class="pr-0">
                    <span class="float-left">{{$t('admin.table_show_result',{result:ajaxToolBonusInfo.total_number})}}</span>
                </b-col>
                <b-col sm="12" md="9" class="pl-0">
                    <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChangeBonusInfo" @current-change="paginationCurrentChangeBonusInfo" :current-page.sync="ajaxToolBonusInfo.current_pagination" :total="ajaxToolBonusInfo.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import {migratePersonalAjaxTable,bonusInfo} from '@/system/model/bonus_report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxToolList:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',master_id:'',total_value:'',is_pay:''},
            ajaxSearchBonusInfo:{limit:'',pagination:'',master_id:'',created_at:'',code:'bonus_migrate_personal'},
            ajaxRow:'',
            ajaxMasterId:'',
            ajaxCreatedAt:'',
            ajaxEdit:[],
            ajaxExportStart:'',
            ajaxExportEnd:'',
            statusList:[],
            showEdit: false,
            pageLimit:10,
            ajaxInfo:'',
            ajaxTableBonusInfo:[],
            ajaxToolBonusInfo:[],
            permission:{
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'118'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'234'
            },{
                prop: "master_id",
                label: this.$t('admin.table_username'),
                width:'234'
            },{
                prop: "total_value",
                label: this.$t('admin.table_total_value'),
                width:'234'
            },{
                prop: "is_pay",
                label: this.$t('admin.table_is_pay'),
                width:'234'
            }],   
            titlesBonusInfo:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'118'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'234'
            },{
                prop: "master_id",
                label: this.$t('admin.table_username'),
                width:'180'
            },{
                prop: "from_master_id",
                label: this.$t('admin.table_from_master_id'),
                width:'180'
            },{
                prop: "total_value",
                label: this.$t('admin.table_total_value'),
                width:'200'
            },{
                prop: "label",
                label: this.$t('admin.table_label'),
                width:'70'
            },{
                prop: "is_pay",
                label: this.$t('admin.table_is_pay'),
                width:'70'
            }],      
        }
    },methods:{
        initialize(){
            var self = this;
            var result = migratePersonalAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.master_id,this.ajaxSearch.total_value,this.ajaxSearch.is_pay);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.preloader(false);
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },infoBonus(){
            var self = this;
            var result = bonusInfo(this.ajaxSearchBonusInfo.limit,this.ajaxSearchBonusInfo.pagination,this.ajaxMasterId,this.ajaxCreatedAt,this.ajaxSearchBonusInfo.code);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxTableBonusInfo = value.data.datatable.data;
                    self.ajaxToolBonusInfo = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.$bvModal.show('infoBonus');
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id;
            this.ajaxMasterId = row.master_id;
            this.ajaxCreatedAt = row.created_at;
            this.showEdit = false;
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        },paginationSizeChangeBonusInfo(limit){
            this.ajaxSearchBonusInfo.limit = limit;
            this.infoBonus();
        },paginationCurrentChangeBonusInfo(pagination){
            this.ajaxSearchBonusInfo.pagination = pagination;
            this.infoBonus();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
